// extracted by mini-css-extract-plugin
export default {"container":"ContactSection__container___pkMRg","info":"ContactSection__info____vNqi"};